import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=01c12640&scoped=true"
import script from "./HeaderUser.vue?vue&type=script&lang=js"
export * from "./HeaderUser.vue?vue&type=script&lang=js"
import style0 from "./HeaderUser.vue?vue&type=style&index=0&id=01c12640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c12640",
  null
  
)

export default component.exports